import { belongsTo, attr } from '@ember-data/model';
import ShModel from './sh-model';

const ApplicationSummary = ShModel.extend({
  activeAt: attr('date'),
  completedAt: attr('date'),
  createdAt: attr('date'),
  createdByUserName: attr('string'),
  direct: attr('boolean'),
  isAwaitingDirectHireOffer: attr('boolean'),
  isRead: attr('boolean'),
  isReadyToMarkComplete: attr('boolean'),
  assignmentId: attr('number'),
  assignmentTitle: attr('string'),
  pitchTitle: attr('string'),
  price: attr(),
  cancellationPrice: attr('number'),
  producerName: attr('string'),
  producerId: attr('number'),
  producerImage: attr('string'),
  producerSlug: attr('string'),
  select: attr('boolean'),
  status: attr('string'),
  statusColor: attr('string'),
  statusText: attr('string'),
  statusEnum: attr('string'),
  actionText: attr('string'),
  threadId: attr('number'),
  title: attr('string'),
  type: attr('number'),
  updatedAt: attr('date'),

  companyTeam: belongsTo('companyTeam', { async: false }),
  thread: belongsTo('thread', { async: false }),
});

export default ApplicationSummary;
